export const sliceId = 'dualTransFinder';
